import React from 'react';

import { Flex } from '@chakra-ui/react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import TextWithEllipsis from 'components/TextWithEllipsis';

import { Realign } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const GenericInputControl = styled(Flex)`
  height: 40px;
  padding: 10px 12px;
  padding-left: 0px;
  align-items: center;
  border-bottom: 1px ${(props) => (props.$isSolidWhenNotActive ? 'solid' : 'dashed')}
    ${(props) => (props.$isReadOnly ? 'transparent' : props.theme.colors.text.g3)};
  &:hover {
    border-bottom-style: solid;
  }
  &:focus-within {
    border-bottom: 1px solid ${(props) => (props.$isReadOnly ? 'transparent' : props.theme.colors.button.blue.default)};
  }
  ${(props) =>
    !props.$isReadOnly && props.$isActive && `border-bottom: 1px solid ${props.theme.colors.button.blue.default};`}
`;

const StyledContainer = styled(Flex)`
  /* height: 40px; */
  padding: 10px 12px;
  padding-left: 0px;
  align-items: center;
  border-bottom: 1px dashed ${(props) => (props.$isReadOnly ? 'transparent' : props.theme.colors.text.g3)};
  &:hover {
    border-bottom-style: solid;
  }
  &:focus-within {
    border-bottom: 1px solid ${(props) => (props.$isReadOnly ? 'transparent' : props.theme.colors.button.blue.default)};
    .realign-icon {
      visibility: ${(props) => (props.$isReadOnly ? 'hidden' : 'visible')};
    }
  }
  ${(props) =>
    !props.$isReadOnly && props.$isActive && `border-bottom: 1px solid ${props.theme.colors.button.blue.default};`}
`;

export const ParentOKRComponent = ({ parentPost, onClick, isReadOnly }) => {
  const theme = useTheme();

  const handleClick = (...args) => {
    if (isReadOnly) return;
    onClick(...args);
  };

  return (
    <StyledContainer className="parent-okr-component" tabIndex={0} onClick={handleClick} $isReadOnly={isReadOnly}>
      <Realign color="#333333" boxSize="18" mr="8px" />

      <TextWithEllipsis linesToShow={2} tooltipText={parentPost?.text} mr="8px">
        <TextBodyMedium className="text-with-ellipsis-tooltip" color={theme.colors.text.g1}>
          {parentPost?.text || 'None'}
        </TextBodyMedium>
      </TextWithEllipsis>
    </StyledContainer>
  );
};
